<script lang="ts">
  export let id: string;
  export let name: string;
  export let label: string = null;
</script>

<label>
  <input {id} {name} type="checkbox" />
  {label}
</label>

<style lang="scss">
  @import "src/lib/styles/variables.scss";

  label {
    font-family: "Roboto";
    font-size: 0.8125rem;
    display: flex;
    color: $color-text;
    line-height: 1.3;

    & > input {
      -moz-appearance: none;
      -webkit-appearance: none;
      -o-appearance: none;
      margin: 0;
      width: 1rem;
      height: 1rem;
      border: 2px solid $color-disabled;
      border-radius: 0.25rem;
      margin-right: 0.5rem;

      &:focus {
        outline: none;
      }

      &:checked {
        padding: 0.125rem;
        background-color: $color-primary;
      }
    }
  }
</style>
